module.exports = __webpack_public_path__ + "static/media/user6.aab5350b.gif";